export const GET_DISCOUNT_COUPONS = 'GET_DISCOUNT_COUPONS'
export const GET_WALLET_HISTORIC = 'GET_WALLET_HISTORIC'
export const SUM_WALLET_TRANSACTIONS = 'SUM_WALLET_TRANSACTIONS'
export const GET_COUPONS_CAMPAIGN = 'GET_COUPONS_CAMPAIGN'